var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operations-type"},[(_vm.label)?_c('FEIcon',{staticClass:"operations-type__icon",attrs:{"size":"30px","name":"winter-wheat"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }